import {getRegisteredList, getUserFollowingDetails} from '@/libs/api/api'
import {message, getImageUrl, onError, logout, errorHandler} from '@/libs/helper'
import {sortBy} from 'lodash'
// import pageRoutes from '../../../../../libs/constant/pageRoutes'
import constants from '@/libs/constant/constants'
import DetailMenu from '@/components/pages/InformationPortal/ProfilePage/DetailMenu/DetailMenu.vue'

export default {
    name: 'Overview',
    beforeMount() {
        this.getUserFollowingDetails()
    },
    components: { DetailMenu },
    props: {
        userInformation: {
            type: Object,
            default: () => {}
        },
        // left menu
        details: {
            type: Object,
            default: () => {}
        },
        routeToDetailPage: {
            type: Function,
            default: () => {}
        },
        selectedRecord: {
            type: Object,
            default: () => {}
        },
        isDossier: {
            type: Boolean,
            default: false
        },
        isCollection: {
            type: Boolean,
            default: false
        },
        getFavorite: {
            type: Function,
            default: () => {}
        },
        setCollectionFavorite: {
            type: Function,
            default: () => {}
        },
        routeToFollowers: {
            type: Function,
            default: () => {} 
        },
        createDetailShortUrl: {
            type: Function,
            default: () => {}
        },
        getShortUrlCollection: {
            type: Function,
            default: () => {}
        },
        collectionShortUrl: {
            type: String,
            default: ''
        },
        shortUrl: {
            type: String,
            default: ''
        },
        getIconClassName: {
            type: Function,
            default: () => {}
        },
        routeToCollectionAboutPage: {
            type: Function,
            default: () => {}
        },
        routeFromCollectionPage: {
            type: Function,
            default: () => {}
        },
        fetchMetaDetails: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            onError,
            getImageUrl,
            authors: [],
            publishers: [],
            publications: [],
            following: {},
        }
    },
    mounted() {
        this.getCardList();
    },
    watch: {
        '$route' (to, from) {
            if (to.name === from.name && to.params && from.params && to.params.id !== from.params.id) {
                // to get the card(maintain) list of user
                this.getCardList()
                // to get the following list of user
                this.getUserFollowingDetails()
            } 
        },
    },
    methods: {
        /**
         * to get the list of maintainer rights
         */
        getCardList () {
            let loading = this.$loading({
                fullscreen: false,
                target: '.member-overview-page',
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.01)'
            });
            let body = {}
            if ((this.userInformation && this.userInformation.id && this.userInformation.id !== this.$route.params.id) || (this.$store.getters.getUserInformation.id !== this.$route.params.id)) {
                body.user_id = this.$route.params.id
            }
            getRegisteredList(body)
            .then((response)=> {
                this.authors = sortBy(response.items.AUTHOR || [], 'name')
                this.publications = sortBy(response.items.PUBLICATION || [], 'name')
                this.publishers = sortBy(response.items.PUBLISHER || [], 'name')
                loading.close()
            }).catch((error)=> {
            loading.close();
            message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /**
         * to get the following rights of the member
         */
        getUserFollowingDetails () {
            // api call
            let body = {}
            if ((this.userInformation && this.userInformation.id && this.userInformation.id !== this.$route.params.id) || (this.$store.getters.getUserInformation.id !== this.$route.params.id)) {
                body.user_id = this.$route.params.id
            }
            getUserFollowingDetails(body).then(response => {
                this.$set(this.following, 'authors', response.authors)
                this.$set(this.following, 'publications', response.publications)
                this.$set(this.following, 'publishers', response.publishers)
            }).catch(error => {
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        }
    }
}